const AccreditationQuestionBlock = ({ index, question, GoToViewer }) => {
    return (
        <div className="Result__Accreditation">
            <p className="Result__Accreditation__Title">{`Pregunta ${index + 1}`}</p>
            
            {question.tasks.map((task, taskIndex) => (
                <div key={taskIndex} className={`Result__Question ${task.result === 0 ? 'Result__Question--Bad' : 'Result__Question--Good'}`}>
                    <div className='Result__Question__Detail'>
                        <p dangerouslySetInnerHTML={{ __html: task.instruction }} />

                        {task.result === 0 ? (
                            <p className="Result__Question__Detail--Bad">{task.analysis}</p>
                        ) : (
                            <p className="Result__Question__Detail--Good">¡Correcto!</p>
                        )}
                    </div>
                    
                    {task.result === 0 && (
                        <button type='button' className='Result__Question__Buttons--Bad' onClick={() => GoToViewer(task)}>Ir al tema</button>
                    )}
                </div>
            ))}
        </div>
    )
}

export { AccreditationQuestionBlock };